import Text from "../../Components/Text/Text";
import { ReactComponent as RightTriangleSvg } from "../../assets/svgs/right-triangle.svg";
import Img1 from '../../assets/images/home/custom-development.png'
import Img2 from '../../assets/images/home/mobile-development.png'
import Img3 from '../../assets/images/home/ai-automation.png'
import Img4 from '../../assets/images/home/data-infrastructure.png'
import { useRef } from "react";
import { useWindowScroll } from "../../hooks/useWindowScroll";
import { useState } from "react";
import { useEffect } from "react";
import { Link } from "react-router-dom";

const dataList = [
  {
    src: Img1,
    title: 'Custom Web Development',
    description: "High-impact, business-driven web solutions",
    path: '/services/web-application-development'
  },
  {
    src: Img2,
    title: 'Mobile App Development',
    description: "Scalable, intuitive mobile user experiences",
    path: '/services/mobile-application-development'
  },
  {
    src: Img3,
    title: 'AI & Intelligent Automation',
    description: "Leveraging predictive analytics for competitive advantage",
    path: '/services/artificial-intelligence'
  },
  {
    src: Img4,
    title: 'Data Infrastructure & Strategy',
    description: "Building resilient, future-ready data ecosystems",
    path: '/enterprises/software-integration'
  },
]

export function RenderContent ({ item, index, show }) {
  const [active, setActive] = useState(false);
  
  useEffect(() => {
    const time = show ? index * 300 : 0;
    const timeId = setTimeout(() => setActive(show), time);
    return () => clearTimeout(timeId);
  }, [show, index]);

  return (
    <Link to={item.path} className={`flex-1 transition-all duration-700 delay-150 ${active ? "" : "opacity-0 translate-y-96"}`}>
      <div 
        className={`bg-white p-10 max-md:p-6 rounded-3xl min-w-[679px] max-md:min-w-full transition-transform duration-250 ease-in-out hover:-translate-y-1 hover:shadow-lg overflow-hidden`}>
          <div className='flex justify-center items-center'>
            <img src={item.src} alt={item.title} className="mb-10" />
          </div>
          <Text type="h1" size="d3" className="mb-6 font-bold mt-4">{item.title}</Text>
          <Text type="p" className="text-lg">
            {item.description}
          </Text>
      </div>
    </Link>
  )
}

export default function HighImpactSoftwareSection() {
  const ref = useRef();
  const { y, height } = useWindowScroll();

  const { offsetTop: elOffsetTop } = ref?.current || {};
  const boundary = elOffsetTop - height / 1.5;
  const show = y > boundary;

  return (
    <div 
      className="relative" 
      style={{
        background: "radial-gradient(circle, #8c2926, #6c1513)"
      }}
      ref={ref}
    >
      <div className="py-[320px] max-md:py-[120px] mx-auto container px-4" >
        <Text 
          type="h1" 
          size="d5" 
          className={`mb-6 text-white transition-all duration-700  ${
            show ? "" : "opacity-0 translate-x-96"
          }`}
        >Turn Vision Into High-Impact Software </Text>
        <Text 
          type="span"
          className={`text-white text-lg max-w-[564px] font-normal transition-all duration-700 ${show ? "" : "opacity-0 translate-y-96"}`}
        >
          We are continuously exploring emerging technologies to push boundaries and drive innovation.
        </Text>
        <div className="flex mt-16 gap-16 flex-wrap max-md:flex-col max-md:gap-6">
          {
            dataList.map((item, index) => (<RenderContent key={index} item={item} show={show} />))
          }
        </div>
        <Link to="/services">
          <Text 
            type="span" 
            className={`mt-16 text-white text-xl relative after:content-[''] inline-block after:inline-block after:w-full after:h-[2px] after:bg-yellow-500 after:absolute after:-bottom-3 after:left-0 transition-all duration-700  ${
              show ? "" : "opacity-0 translate-x-96"
            }`}
          >
            EXPLORE ALL SERVICES
          </Text>
        </Link>
      </div>
      <RightTriangleSvg className="transition-all absolute bottom-0 fill-white animate-raise-up w-full" />
    </div>
  );
}